export default __webpack_public_path__ + "static/media/nft-reward.3c439fb8.png";